import { NodeId, SerializedNodes } from '@craftjs/core';
import { useRef } from 'react';
import { useModal } from 'src/application/hooks/useModal';
import { GeneralFormFillingModal } from 'src/features/generalForms/fillingModal/GeneralFormFillingModal';
import { IBaseScoreSection, IBaseVariableSection } from 'src/services/api/api-client';
import { LayoutAttachmentType } from '../context/attachments.context';
import { ProcessAnswerFuncType, UploadFileFuncType } from './GeneralFormFillingModal.t';

export type useGeneralFormFillingModalArgs = {
  processAnswerFunc: ProcessAnswerFuncType | undefined;
  uploadFileFunc: UploadFileFuncType | undefined;
};

export type FormFillingInitialData = {
  scoreSections: IBaseScoreSection[];
  variables: IBaseVariableSection[];
  layout: SerializedNodes;
  initialValue: Record<string, any> | undefined | null;
  resultId: number | undefined | null;
  modalTitle: string;
  initialAttachments?: Record<NodeId, LayoutAttachmentType>;
};

export const useGeneralFormFillingModal = (handlers: useGeneralFormFillingModalArgs) => {
  const modal = useModal();
  const initialDataRef = useRef<FormFillingInitialData>();

  return {
    open: (initialData: FormFillingInitialData) => {
      initialDataRef.current = initialData;

      if (!initialData) return;
      modal.openModal();
    },
    modal: modal.visible && (
      <GeneralFormFillingModal
        onClose={modal.closeModal}
        processAnswerFunc={handlers.processAnswerFunc}
        uploadFileFunc={handlers.uploadFileFunc}
        initialData={initialDataRef.current}
      />
    ),
  };
};
